import { render, staticRenderFns } from "./bucketTypesList.vue?vue&type=template&id=74785012&scoped=true&"
import script from "./bucketTypesList.vue?vue&type=script&lang=js&"
export * from "./bucketTypesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74785012",
  null
  
)

export default component.exports